import api from "../../utils/ApiConfig";

export const fetchAccountDeletionRequests = async (page = 1, searchTerm = "", status = "") => {
  try {
    const params = {
      page: page,
      per_page: 50,
      search: searchTerm,
    };

    // Only add status filter if it's not empty
    if (status) {
      params.status = status;
    }

    const response = await api.get(`/bo/account-deletion-requests`, {
      params: params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching account deletion requests:", error);
    throw error;
  }
};

export const fetchAccountDeletionRequestStats = async () => {
  try {
    const response = await api.get(`/bo/account-deletion-requests/stats`);
    return response.data;
  } catch (error) {
    console.error("Error fetching stats:", error);
    throw error;
  }
};

export const updateAccountDeletionRequest = async (id, data) => {
  try {
    const response = await api.put(`/bo/account-deletion-requests/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating account deletion request:", error);
    throw error;
  }
};

export const deleteAccountDeletionRequest = async (id) => {
  try {
    const response = await api.delete(`/bo/account-deletion-requests/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting account deletion request:", error);
    throw error;
  }
};
